module.exports = __webpack_public_path__ + "static/media/iv_elss.3f4c0bc2.svg";